import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import { ColorBoxContent } from 'common/ui/colorBox'
import useOrbitFlag from 'hooks/useOrbitFlag'
import { SimTable, TeamMemberProps } from 'pages/SIMs/ManageSims/SimManagement'
import PropTypes from 'prop-types'

interface TeamMembersCellProps {
  teamMembers: TeamMemberProps[]
}

function TeamMembersCell(props: TeamMembersCellProps) {
  const navigate = useNavigate()
  const FlagManageSimBtn = useOrbitFlag('dashboard-manageSimBtn')
  return (
    <ColorBoxContent>
      <SimTable
        teamMembers={props.teamMembers}
        pageRows={[-1]}
        customToolbarComponent={
          FlagManageSimBtn && (
            <Button
              variant='contained'
              id='manageSimsBtn'
              size='small'
              onClick={() => navigate('/app/manage-sims')}
            >
              Manage SIMs
            </Button>
          )
        }
        refresh={()=>void 0}
      />
    </ColorBoxContent>
  )
}

TeamMembersCell.propTypes = {
  bundle: PropTypes.object,
  bundleUsage: PropTypes.object,
  teamMembers: PropTypes.array
}

export default TeamMembersCell
